import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
    return (
        <div className="footer-section">
            <Container>
                <p>Designed and Developed by <a href="https://github.com/chandan-mandi">Chandan Mandi</a> </p>
            </Container>
        </div>
    );
};

export default Footer;